import React from "react";
import MinusIcon from "@components/Icons/MinusIcon";
import PlusIcon from "@components/Icons/PlusIcon";
import Button from "@components/Ui/Button";
import "./style.scss";

const NumberInput = ({ value, setValue }) => {
    const displayValue = Number.isInteger(value) && value > 0
        ? value
        : "";
    const localValue = Number.isInteger(value) && value > 0
        ? value
        : 0;
    return (
        <div className="number-input">
            <Button
                aria-label="Decrease quantity"
                additionalClasses="number-input__minus"
                onClick={() => {
                    const val = parseInt(localValue) - 1;
                    setValue(val > 0 ? val : 0);
                }}>
                <MinusIcon className="number-input__svg" />
            </Button>
            <input
                type="text"
                aria-label="quantity"
                value={displayValue}
                className="number-input__text"
                placeholder="0"
                onChange={(e) => setValue(parseInt(e.target.value) || 1)}
            />
            <Button
                aria-label="Increase quantity"
                additionalClasses="number-input__plus"
                onClick={() => setValue(parseInt(localValue) + 1)}>
                <PlusIcon className="number-input__svg" />
            </Button>
        </div>
    );
};

export default NumberInput;
